
// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ExploreStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import { observable, action, computed, toJS } from 'mobx';
import fetcher from 'fetchers/Izenda.ExploreFetcher';
import nlqfetcher from 'fetchers/Izenda.NLQFetcher';
import AlertDetails from 'logic/models/Izenda.AlertDetails';
import ExploreModel from 'logic/models/Izenda.Explore';
import EXPLORE_CTA_CONSTANTS from 'logic/data/Izenda.ExploreCtaConstants';
import AppStore from 'logic/Izenda.AppStore';
import { getOr, find, isArray, orderBy,every,flow,groupBy,map,head } from 'lodash/fp';
import DashboardStore from 'logic/Izenda.DashboardStore';
import uiState from 'logic/Izenda.UiState.js';
import routeUtils from 'share/utils/Izenda.RouteUtils';
import localizer from 'share/localization/Izenda.Localizer';
import { REPORT_MODE } from 'logic/data/Izenda.ExportConstants';
import {
  COMPLETED,
  ERROR,
  SEARCH_MODE
} from 'logic/data/Izenda.NLQConfigurationConstants';
import notificationFetcher from 'fetchers/Izenda.NotificationFetcher';
import {MESSAGES} from 'logic/data/Izenda.NotificationConstants';

export default class ExploreStore {
  @observable model;
  @observable storeDashboard;
  @observable alertDetails;

  @observable originalAllQuerySourceFields=[];
  @observable availableAllQuerySourceFields=[];
  @observable checkedQuerySources=[];
  @observable categoriesTypes;
  @observable ctaContent = null;
  @observable isNlqNotConfig;
  @observable noConfigPlaceHolder;
  @observable searchMode;
  @observable paging;
  @observable sortOrders;
  @observable isExploreView;

  constructor() {
    this.model = new ExploreModel();
    this.alertDetails = new AlertDetails();
    this.categoriesTypes = [];
    this.ctaContent = EXPLORE_CTA_CONSTANTS.EXPLORE_CTAS;
    this.storeDashboard = new DashboardStore();
    this.isNlqNotConfig = true;
    this.noConfigPlaceHolder = '';
    this.searchMode = 0;
    this.paging = {};
    this.sortOrders = [];
    this.isExploreView = true;
  }

  @computed
  get getSearchstring() {
    return this.model.searchString;
  }
  @computed
  get getnlpDict() {
    return this.model.nlpDict;
  }
  @computed
  get getactiveTab() {
    return this.model.activeTab;
  }
  @computed
  get getSuggestionSearchList() {
    return this.model.suggestionSearchList;
  }
  @computed
  get getSetResults() {
    return this.model.setResults;
  }
  @computed
  get getShowResult() {
    return this.model.showResult;
  }

  @computed
  get getisTobeSearch() {
    return this.model.isTobeSearch;
  }
  @computed
  get getISMLError() {
    return this.model.isMLError;
  }

  @computed
  get getResultReportDefinition() {
    return this.model.resultReportDefinition;
  }

  @computed
  get getResultReportRecords() {
    return this.model.resultReportRecords;
  }

  @computed
  get getVisualizationRecords() {
    return this.model.nlqVisualizationRecords;
  }

  @computed
  get getVisualizationRecommendationList() {
    return this.model.visualizationRecommendationList;
  }

  @computed
  get getNoOFColumns() {
    return this.model.noOfColumns;
  }

  @computed
  get getNoOfTotalRecords() {
    return this.model.noOfTotalRecords;
  }

  @action
  resetAlertDetails() {
    this.alertDetails.reset();
  }

  @action
  SetISMLError() {
    if (
      this.model.nlqDataandSchemaInfo == null ||
      (this.model.nlqDataandSchemaInfo.nlqFustionResult == null &&
        this.model.nlqDataandSchemaInfo.reportDefinition == null)
    ) {
      this.model.isMLError = true;
    } else {
      this.model.isMLError = false;
    }
  }

  @action
  SetISTobeSearch(value) {
    this.model.isTobeSearch = value;
  }

  ReSetSetResults() {
    this.model.setResults = [];
  }

  @action
  setSearchstring(value) {
    this.model.searchString = value;
  }

  @action
  setSuggestionChangeModel(data: any) {
    if (this.model.suggestionSearchList.length == 0) this.model.suggestionSearchList.push(data.suggestions);
    else {
      let suggestionList = [...this.model.suggestionSearchList[0], ...data.suggestions];
      this.model.suggestionSearchList = [];
      this.model.suggestionSearchList.push(suggestionList);
    }
  }

  @action
  setSuggestionSubmitModel(data: any) {
    this.model.activeTab = 2;
    this.model.nlqDataandSchemaInfo = data;
    this.model.resultReportDefinition = data.reportDefinition;
    this.model.resultReportRecords = data.nlqFustionResult;
    this.model.noOfColumns = data && data.nlqFustionResult && data.nlqFustionResult.fieldsMapping;
    this.model.noOfTotalRecords = data && data.nlqFustionResult && data.nlqFustionResult.paging.totalRecord;
    this.SetISMLError();
    this.model.nlpDict = '{}';
  }

  @action
  showSuggestResult(IsTobeSearch) {
    
      return fetcher.suggestResult(this.getSearchstring, IsTobeSearch, this.getnlpDict,uiState.getTenantId(),this.searchMode);
  }

  @action
  getreportPartVisualization(data) {
    return fetcher.getreportPartVisualization(this.buildVisuaizationRequest(data));
  }

  @action
  defaultVisualizationHandler(response) {
    let self = this;
    self.model.nlqVisualizationRecommendationList = response.nlqVisualizationRecommendationList;
    self.resetIsRecommendationfromVisalizationList();
    if (response.nlqVisualizationRecommendationList && self.model.nlqVisualizationRecommendationList.length > 0) {
      self.model.resultReportDefinition = null;
      self.model.visualizationRecommendationList.map(x => {
        if (response.nlqVisualizationRecommendationList.filter(e => e.visualizationType == x.chartType).length > 0)
          x.isRecommended = true;
      });
      self.model.nlqVisualizationRecords = response.nlqFustionResult;
      self.model.resultReportRecords = response.nlqFustionResult;
      self.model.visualizationRecommendationList = orderBy(
        ['isRecommended'],
        ['desc'],
        self.model.visualizationRecommendationList
      );

      const defualtRecommendedVisulationDefinition = this.model.nlqVisualizationRecommendationList.filter(
        e => e.visualizationType == self.model.visualizationRecommendationList[0].chartType
      );

      self.model.nlqVisualizationReportDefinition =
        defualtRecommendedVisulationDefinition[0].visualizationReportDefinition;
    }
  }

  resetIsRecommendationfromVisalizationList() {
    const { isSave, isRecommended, isDashboardSave, reportId, reportName } = this.defaultValuesofVisualitontype();
    this.model.visualizationRecommendationList.map(x => {
      x.isSave = isSave;
      x.isDashboardSave = isDashboardSave;
      x.reportId = reportId;
      x.reportName = reportName;
      if (x.chartType != 'Grid') {
        x.isRecommended = isRecommended;
      }
    });
    this.model.visualizationRecommendationList = orderBy(
      ['position'],
      ['asc'],
      this.model.visualizationRecommendationList
    );
  }

  defaultValuesofVisualitontype() {
    const visualizationTypeDefaultValuses = {
      isRecommended: false,
      isSave: false,
      isDashboardSave: false,
      reportId: '',
      reportName: ''
    };
    return visualizationTypeDefaultValuses;
  }

  @action
  updateGetVisualizationRequest(reportData) {
    this.model.nlqDataandSchemaInfo.nlqVisualizationReportDefinition = reportData;
    this.model.nlqDataandSchemaInfo.reportDefinition = reportData;
    this.model.resultReportDefinition = reportData;
  }

  @action
  updateGetVisualizationRecords(recordsResult) {
    this.model.nlqVisualizationRecords = recordsResult;
    this.model.noOfColumns = recordsResult.fieldsMapping;
    this.model.noOfTotalRecords = recordsResult.paging.totalRecord;
    this.model.nlqDataandSchemaInfo.nlqFustionResult = recordsResult;
  }

  @action
  getConfigureNLQStatus() {
    return nlqfetcher.getConfigureNLQStatus(uiState.getTenantId());
  }

  buildVisuaizationRequest(data) {
    let request = {};
    request.reportKey = {TenantId: uiState.getTenantId()};
    request.section = 2;
    request.saveAs = false;
    request.isTotalRecordQueryEnable = true;
    request.ignoreCheckChange = false;
    request.isSavingReport = false;
    request.report = data;
    request.report.reportMode = REPORT_MODE;
    request.expandedLevel = -1;
    request.ignoreCache = false;
    request.title = 'Grid';
    request.paging = this.paging;
    request.sortOrders = this.sortOrders;
    request.filters = [];
    request.reportMode = 1;
    return request;
  }

  getSearchResult(indexSet, options) {
    return this.search(toJS(this.getSuggestionSearchList[indexSet]), this.getSearchstring);
  }

  search(data, searchString) {
    if (!data) return;
    let result = [];
    for (var i = 0; i < data.length; i++) {
      let record = data[i].name;
      if (record.toUpperCase().indexOf(searchString.toUpperCase()) > -1) {
        result.push(data[i]);
      }
    }
    return result;
  }
 
  @action
  initializeAskYourQueryValue = () => {
    this.model.activeTab = 1;
    this.model.showResult = false;
    this.model.resultReportDefinition = null;
    this.model.isMLError = false;
    this.SetISTobeSearch(false);
    this.setSearchstring('');
    this.model.nlpDict = '';
    this.model.nlqDataandSchemaInfo = null;
    //  this.model.setResults = this.getSuggestionSearchList[0];
    this.ReSetSetResults();
    this.model.nlqVisualizationReportDefinition = null;
  };
  @action
  SetRecentReportView = () =>{
     fetcher.getRecentReports(uiState.getTenantId()).then(response=>{
      this.model.recentReportViewList = response;
     });
  };
  @action
  initializeQueryResultValue = () => {
    if (this.getisTobeSearch) {
      this.model.activeTab = 2;
      this.model.showResult = true;
    } else if (this.model.nlqVisualizationReportDefinition != null) {
      this.model.activeTab = 2;
      this.model.resultReportDefinition = this.model.nlqDataandSchemaInfo.reportDefinition;
      this.model.resultReportRecords = this.model.nlqDataandSchemaInfo.nlqFustionResult;
      this.model.noOfColumns = this.model.nlqDataandSchemaInfo.nlqFustionResult.fieldsMapping;
      this.model.noOfTotalRecords = this.model.nlqDataandSchemaInfo.nlqFustionResult.paging.totalRecord;
      this.model.nlqVisualizationReportDefinition = null;
    } else if (
      this.model.nlqVisualizationRecommendationList.length == 0 &&
      this.model.nlqDataandSchemaInfo != null &&
      !this.getisTobeSearch
    ) {
      this.model.activeTab = 2;
      this.model.resultReportDefinition = this.model.nlqDataandSchemaInfo.reportDefinition;
      this.model.resultReportRecords = this.model.nlqDataandSchemaInfo.nlqFustionResult;
      this.model.noOfColumns = this.model.nlqDataandSchemaInfo.nlqFustionResult.fieldsMapping;
      this.model.noOfTotalRecords = this.model.nlqDataandSchemaInfo.nlqFustionResult.paging.totalRecord;
    }
  };

  @action
  initializeVisualizationValue = () => {
    this.model.activeTab = 3;
    this.model.isTobeSearch = false;
  };

  @action
  loadSearchList = searchString => {
    this.setSearchstring(searchString);
    var result = [];
    let setNumber = 0;
    // let numberoFSets = this.getSuggestionSearchList.length;
    // let breakStatement = false;
    result = this.getSearchResult(0, 'options');
    this.SetResults(result, setNumber);
  };
  @action
  setNLPDict(value) {
    this.model.nlpDict = value;
  }

  resetResult() {
    this.ReSetSetResults();
  }

  SetResults(result, setNumber) {
    let self = this;
    this.ReSetSetResults();

    if (result && result.length > 0) {
      self.model.setResults = result;
      this.model.showResult = false;
    } else {
      this.getSearchSuggestions();
    }
  }
  @action
  setVisualizationRecommendation = selectedVisualization => {
    let reportDef = this.model.nlqVisualizationRecommendationList.filter(
      e => e.visualizationType == selectedVisualization.chartType
    );

    this.change1(reportDef[0].visualizationReportDefinition);

    let promiseResolveQuery = Promise.resolve();
    let self = this;
    promiseResolveQuery.then(() => {
      self.model.nlqVisualizationReportDefinition = reportDef[0].visualizationReportDefinition;

      return Promise.resolve(false);
    });
  };

  @action
  updateReportDefnitionInfo(data) {
     this.paging = data.paging;
     this.sortOrders = data.sortOrders;
  }

  @action
  change1(value) {
    this.model.nlqVisualizationReportDefinition = Object.assign({}, value);
  }
  getSearchSuggestions() {
    if(this.searchMode!=SEARCH_MODE.NATURAL)
    {
    let self = this;
    this.ReSetSetResults();
    this.showSuggestResult(false).then(response => {
      self.setSuggestionChangeModel(response.data);
      self.model.setResults = response.data.suggestions;
      self.model.nlpDict = response.data.dict == null ? '{}' : response.data.dict;
    });
  }
  }

  getALLReports(dataObject) {
    return fetcher.getALLReports(dataObject);
  }

  @action
  async loadALLReports(dataObject, store) {
    this.model.loadCategoriesHiearchy = [];
    dataObject = {
      tenantId: this.tenantId,
      // type: reportType,
      isUncategorized: false,
      skipItems: 0,
      pageSize: 100000,
      parentIds: [],
      includeGlobalCategory: true,
      isGlobal: null,
      criterias: [{ key: 'CategoryId' }]
    };
    const reportCategoies = await AppStore.loadCategorySettings();
    const categoryList = await this.getALLReports(dataObject);
    this.categoriesTypescategoriesTypes = reportCategoies;
    const globalReportType = find({ isGlobal: true }, reportCategoies);
    const localReportType = find({ isGlobal: false }, reportCategoies);
    let localCategories = find({ isGlobal: false }, categoryList.data);
    let globalCategories = find({ isGlobal: true }, categoryList.data);

    if (globalCategories == undefined) {
      globalCategories = [];
    }
    if (localCategories == undefined) localCategories = [];

    this.model.loadCategoriesHiearchy.push(this.getlocalCategory(localReportType, toJS(localCategories)));
    this.model.loadCategoriesHiearchy.push(this.getGlobalCategory(globalReportType, toJS(globalCategories)));
    this.model.OriginalLoadCategoriesHiearchy = toJS(this.model.loadCategoriesHiearchy);
  }

  getSubcategories(categoryList) {
    let subCategories = [];

    const subCategoriesList = isArray(categoryList)
      ? getOr([], 'subCategories', categoryList[0])
      : getOr([], 'subCategories', categoryList);

    subCategoriesList.forEach(function (result, index) {
      let subCategory = {};
      const name = getOr(null, 'name', result);
      const id = getOr(null, 'id', result);
      subCategory.isOpen = false;
      subCategory.newSubCategory = '';
      subCategory.newReport = '';
      subCategory.reportNameErrorClass = false;

      subCategory.currentSubCategory = '';
      subCategory.currentReport = '';
      const parentId = getOr(null, 'parentId', result);
      subCategory.id = id;
      subCategory.name = name ? name : 'Uncategorized';
      subCategory.parentId = parentId;
      if (
        result.subCategories.length > 0 &&
        result.subCategories[0].name == null &&
        result.subCategories[0].reports.length > 0 &&
        result.subCategories[0].parentId != null
      ) {
        subCategory.reports = getOr([], 'reports', result.subCategories[0]);
      }
      subCategories.push(subCategory);
    });
    return subCategories;
  }

  getdefaultSubcategories(defaultSubCategoryname) {
    let subCategories = [];
    let subCategory = {};
    subCategory.name = defaultSubCategoryname;
    subCategory.id = null;
    subCategory.parentId = null;
    subCategory.isOpen = false;
    subCategory.reportNameErrorClass = false;
    subCategory.dashboardNameErrorCls = false;
    subCategory.reports = [];
    (subCategory.isReportVisible = false), subCategories.push(subCategory);
    return subCategories;
  }
  getdefaulDashboardtSubcategories(defaultSubCategoryname) {
    let subCategories = [];
    let subCategory = {};
    subCategory.name = defaultSubCategoryname;
    subCategory.id = null;
    subCategory.parentId = null;
    subCategory.isOpen = false;
    subCategory.reportNameErrorClass = false;
    subCategory.dashboardNameErrorCls = false;
    subCategory.dashboards = [];
    subCategory.reports = [];
    (subCategory.isDashBoardVisible = false), subCategories.push(subCategory);
    return subCategories;
  }

  getlocalCategory(data, catgeoryData) {
    let dataCategorylocal = {};
    dataCategorylocal.id = getOr(null, 'id', data);
    dataCategorylocal.name = getOr(null, 'name', data);
    dataCategorylocal.isGlobal = getOr(null, 'isGlobal', data);
    dataCategorylocal.isOpen = false;
    dataCategorylocal.SubCategory = [];
    dataCategorylocal.isVisible = false;
    dataCategorylocal.subcategoryNameErrorClass = false;
    if (catgeoryData && catgeoryData.subCategories && catgeoryData.subCategories.length > 0) {
      dataCategorylocal.SubCategory = this.getSubcategories(catgeoryData);
    } else {
      dataCategorylocal.SubCategory = this.getdefaultSubcategories('Uncategorized');
    }
    return dataCategorylocal;
  }

  getGlobalCategory(data, catgeoryData) {
    let dataCategoryGlobal = {};
    dataCategoryGlobal.id = getOr(null, 'id', data);
    dataCategoryGlobal.name = getOr(null, 'name', data);
    dataCategoryGlobal.isGlobal = getOr(null, 'isGlobal', data);
    dataCategoryGlobal.isOpen = false;
    dataCategoryGlobal.SubCategory = [];
    dataCategoryGlobal.isVisible = false;
    dataCategoryGlobal.subcategoryNameErrorClass = false;
    if (catgeoryData && catgeoryData.subCategories && catgeoryData.subCategories.length > 0) {
      dataCategoryGlobal.SubCategory = this.getSubcategories(catgeoryData);
    } else {
      dataCategoryGlobal.SubCategory = this.getdefaultSubcategories('Uncategorized');
    }
    return dataCategoryGlobal;
  }
  /**Dashboard Hiearchy */
  getDashboardLocalCategory(data, catgeoryData) {
    let dataCategorylocal = {};
    dataCategorylocal.id = getOr(null, 'id', data);
    dataCategorylocal.name = getOr(null, 'name', data);
    dataCategorylocal.isGlobal = getOr(null, 'isGlobal', data);
    dataCategorylocal.isOpen = false;
    dataCategorylocal.SubCategory = [];
    dataCategorylocal.isVisible = false;
    dataCategorylocal.subcategoryNameErrorClass = false;
    if (catgeoryData && catgeoryData.length > 0) {
      catgeoryData.forEach(result => {
        dataCategorylocal.SubCategory.push(this.getDashboardSubcategories(result));
      });
    } else {
      dataCategorylocal.SubCategory = this.getdefaulDashboardtSubcategories('Uncategorized');
    }
    return dataCategorylocal;
  }

  getDashboardSubcategories(result) {
    let subCategory = {};
    const name = getOr(null, 'name', result);
    const id = getOr(null, 'id', result);
    subCategory.isOpen = false;
    subCategory.isDashBoardVisible = false;
    subCategory.dashboardNameErrorCls = false;
    subCategory.newSubCategory = '';
    subCategory.newDashBoard = '';
    subCategory.currentSubCategory = '';
    subCategory.currentDashboard = '';
    const parentId = getOr(null, 'parentId', result);
    subCategory.id = id;
    subCategory.name = name ? name : 'Uncategorized';
    subCategory.id = parentId;

    if (result.subCategories && result.subCategories[0].dashboards.length > 0) {
      subCategory.dashboards = result.subCategories[0].dashboards;
    }
    return subCategory;
  }

  getDashboardGlobalCategory(data, catgeoryData) {
    let dataCategoryGlobal = {};
    dataCategoryGlobal.id = getOr(null, 'id', data);
    dataCategoryGlobal.name = getOr(null, 'name', data);
    dataCategoryGlobal.isGlobal = getOr(null, 'isGlobal', data);
    dataCategoryGlobal.isOpen = false;
    dataCategoryGlobal.SubCategory = [];
    dataCategoryGlobal.isVisible = false;
    dataCategoryGlobal.subcategoryNameErrorClass = false;
    if (catgeoryData && catgeoryData.length > 0) {
      catgeoryData.forEach(result => {
        dataCategoryGlobal.SubCategory.push(this.getDashboardSubcategories(result));
      });
    } else {
      dataCategoryGlobal.SubCategory = this.getdefaulDashboardtSubcategories('Uncategorized');
    }
    return dataCategoryGlobal;
  }

  @action
  destroyloadCategoriesHiearchy() {
    this.model.loadCategoriesHiearchy = [];
  }

  async loadDashboardList() {
    const pageInfo = {
      fromIndex: 0,
      pageSize: 100,
      parentIds: []
    };
    const reportCategoies = await AppStore.loadCategorySettings();
    const dashboardList = await this.storeDashboard.loadDashboardList(pageInfo);

    const globalReportType = find({ isGlobal: true }, reportCategoies);
    const localReportType = find({ isGlobal: false }, reportCategoies);
    let localCategories = dashboardList.filter(items => items.isGlobal == false);
    let globalCategories = dashboardList.filter(items => items.isGlobal == true);

    if (globalCategories == undefined) {
      globalCategories = [];
    }
    if (localCategories == undefined) localCategories = [];

    this.model.loadDashboardCategoriesHiearchy.push(this.getDashboardLocalCategory(localReportType, localCategories));
    this.model.loadDashboardCategoriesHiearchy.push(this.getGlobalCategory(globalReportType, toJS(globalCategories)));
    this.model.OriginalloadDashboardCategoriesHiearchy = toJS(this.model.loadDashboardCategoriesHiearchy);
  }

  async loadDashboardListNLQ(catId, isGlobal) {
    const pageInfo = {
      fromIndex: 0,
      pageSize: 100,
      parentIds: []
    };
    if (catId != 'null') {
      catId = String.isGuidFormat(catId) ? catId : null;
    }
    await this.storeDashboard.lazyLoadingDashboards(catId, true, isGlobal, pageInfo);
  }

  @action
  setNLQStatus(nlqConfigStatus) {
    this.searchMode =nlqConfigStatus.searchMode;
    if (nlqConfigStatus.status === COMPLETED) {
     if(nlqConfigStatus.isDataModelAccess)
      {
        this.isNlqNotConfig = false;
        this.noConfigPlaceHolder = localizer.getText('EXPLORE_SEARCH_PLACEHOLDER');
        if(!nlqConfigStatus.isNLQSchemaVisible)
        {
          this.isNlqNotConfig = true;
          this.noConfigPlaceHolder = 'Active NLQ schema is disabled';
        }
      }
      else
      {
        this.isNlqNotConfig = true;
        this.noConfigPlaceHolder = localizer.getText('EXPLORE_SEARCH_ISDATAMODELACCESS');
      }
    }
    else {
      this.isNlqNotConfig = true;
      this.noConfigPlaceHolder = localizer.getText('EXPLORE_SEARCH_NLQ_NOT_CONFIGURED');
    }
    this.updateNLQConfigurationNotify(nlqConfigStatus);
  }
  updateNLQConfigurationNotify(nlqStatusResult) {
    
    if (!nlqStatusResult.isDataModelAccess && nlqStatusResult && nlqStatusResult.status === ERROR && nlqStatusResult.isMLCall) {

      notificationFetcher
      .addNotification({ notificationMessageID: MESSAGES.CONFIGURE_NLQ_FAILED.id })
      .then(() => {
        uiState.setUpdateNotifications();
      });

      return;
    }

    if (nlqStatusResult && nlqStatusResult.status === ERROR && nlqStatusResult.isMLCall) {

      notificationFetcher
      .addNotification({ notificationMessageID: MESSAGES.CONFIGURE_NLQ_FAILED.id })
      .then(() => {
        uiState.setUpdateNotifications();
      });

      return;
    }

    if (nlqStatusResult && nlqStatusResult.status === COMPLETED && nlqStatusResult.isMLCall) {
     
      notificationFetcher
      .addNotification({ notificationMessageID: MESSAGES.CONFIGURE_NLQ_SUCCESSFUL.id })
      .then(() => {
        uiState.setUpdateNotifications();
      });

      return;
    }
  }

  preview(reportId) {
    var viewReportUrl = {
      pathname: routeUtils.getReportUrl('View', { id: reportId }),
      state: {
        fromReportDesigner: false
      }
    };
    this.props.router.push(viewReportUrl);
  }
 
  @action
  setNLQSaveReportNotification(Dashboard, Id, Name) {
    if (Id) {
     let isDashboard = Dashboard ? true : false;
  
    if (Id) {
     var replaceNotificationMsgVale = isDashboard+","+Id+","+Name;
     notificationFetcher
            .addNotification({ notificationMessageID: MESSAGES.SAVE_NLQ_REPORT_SUCCESS.id,replaceValues : replaceNotificationMsgVale })
            .then(() => {
              uiState.setUpdateNotifications();
            });
     return;
    }
   }
  }
  @computed
  get getNLQStatus() {
    return this.isNlqNotConfig;
  }
  @computed
  get getNoConfigPlaceHolder() {
    return this.noConfigPlaceHolder;
  }

  resetStoreDashboard() {
    this.storeDashboard = new DashboardStore();
  }

  // @action
  getAddCategoryTreeItem(categoriesHiearchy, name, index) {
    if (name & (name.trim() == '') || !name) {
      return false;
    }
    const newCategoryTreeItem = {
      id: null,
      type: index,
      name: name,
      parentId: null,
      state: 0,
      modified: null,
      canDelete: false,
      dashboards: [],
      reports: [],
      checked: false,
      indeterminate: false,
      numOfCheckedChilds: 0,
      numOfChilds: 0,
      isGlobal: categoriesHiearchy[index].isGlobal,
      // isEditing: true,
      // editable: true,
      tenantId: uiState.getTenantId()
    };

    return newCategoryTreeItem;
  }

  @computed
  get getRecentReportViewList() {
    return this.model.recentReportViewList;
  }


  getAvailableQuerySourceFields(data,reportdesinerfieldStore)
  {
    return fetcher.getAllAvailableQuerySourceFields(data).then(result => {
      this.originalAllQuerySourceFields =result;
      const dataResult = this.UpdateAvailableFiledsCheckedStatus(data);
      this.availableAllQuerySourceFields =dataResult;
      reportdesinerfieldStore.dataTree.readDataSource(dataResult);
      this.checkedQuerySources =[];
    });
  }

  UpdateAvailableFiledsCheckedStatus(data)
  {
  const availableTreeData = toJS(this.originalAllQuerySourceFields); 
  const querySourceFields = data.reportPart[0].reportPartContent.columns.elements.map(x=>x.field.fieldId);
  if(availableTreeData[0].querySource && availableTreeData[0].querySource.length>0)
  {
    availableTreeData[0].querySource.forEach(function(querySourceItem) {
      if(querySourceFields && querySourceFields.length>0)
      {
        querySourceFields.map(selectedField=>{
          const foundField = querySourceItem.fields.filter(x=>x.id==selectedField);
          if(foundField.length>0)
          {
            querySourceItem.fields.splice(querySourceItem.fields.indexOf(foundField[0]),1);
          }

        })
      }    
    });
   }
     return availableTreeData;
  }

  getFilterLogic(filterLogic,position){
    let logic = '';
    if (filterLogic === '' || filterLogic === '1') return logic;
    let logicOperators = filterLogic.match(/[a-zA-Z]+/g);
    if (logicOperators && logicOperators.length === 1)
      return logic;
    let removePositionforOperator = position - 1;
    if (logicOperators.length == removePositionforOperator)
      removePositionforOperator = logicOperators.length - 1;

    logicOperators.splice((removePositionforOperator), 1);


    for (let i = 0; i < logicOperators.length; i++) {
      logic = `${logic} ${i + 1} ${logicOperators[i]}`;
    }
    logic = `${logic} ${logicOperators.length + 1}`;
    return logic;
  }
}



// WEBPACK FOOTER //
// ./ui/logic/Izenda.ExploreStore.js